import { Injectable }   from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { FormBase }     from '../_models/form-base';
import { RegExHelper }  from '../_helpers/regex-helper';
import { AcmicService } from './acmic.service';

@Injectable()
export class FormBaseControlService {
  constructor(
    private regExHelper: RegExHelper,
    private acmicService: AcmicService
  ) { }

  matchPasswords(input: FormControl, group: FormGroup) {
    const password = input.value == group.get('createPassword').value;
    return password ? { matchPasswords: true } : null;
  }

  toFormGroup(inputs: FormBase<any>[] ) {
    const group:            any = {},
        createPasswordPattern = this.regExHelper.passwordRulesPattern['patternForDynamicForm'],
        emailPattern          = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        policyPattern         = this.regExHelper.policyPattern,
        legacyPolicyPattern   = this.regExHelper.legacyPolicyPattern,
        numberPattern         = this.regExHelper.numberPattern,
        datePattern           = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;

    inputs.forEach(input => {
      if (input.key === 'signUpDob' && input["type"] === "dob") {
        group[input.key] = input.required ?
          new FormControl(input.value || '', [
            Validators.required,
            Validators.pattern(datePattern),
            Validators.minLength(input.minLength),
            Validators.maxLength(input.maxLength)
          ]) :
          new FormControl(input.value || '', Validators.pattern(datePattern));
      }
      if ( input.inputType == 'email' ) {
        group[input.key] = input.required ? 
          new FormControl(input.value || '',  [
            Validators.required,
            Validators.pattern(emailPattern),
            Validators.minLength(input.minLength),
            Validators.maxLength(input.maxLength)
          ] ) :
          new FormControl(input.value || '',  Validators.pattern(emailPattern));
      } else if (
        (input.inputType =='password' && input.key != 'createPassword') ||
        (input.inputType =='phone' && input.key == 'accountPhone')      ||
        (input.inputType =='bank')
        ) {
        group[input.key] = new FormControl
        (
          input.value, 
          [
            Validators.required, 
            Validators.minLength(input.minLength), 
            Validators.maxLength(input.maxLength)
          ]
        );
      }
      else if (input.inputType == 'text' && ( input.key.includes('_name') || input.key.includes('Name') || input.key.includes('Holder') )) {
        group[input.key] = input.required ? 
          new FormControl(input.value || '', [Validators.required]) :
          new FormControl(input.value || '')
      } else if (input.key == 'createPassword') {
        group[input.key] = new FormControl
        (
          input.value, 
          [
            Validators.required, 
            Validators.maxLength(input.maxLength),
            Validators.minLength(input.minLength),
            Validators.pattern(createPasswordPattern),
          ]
        );
      }
      else if (input.key == 'addPolicy' || input.key == 'editPolicyNumber' || 
      input.key == 'makePayment_policy' || (input.key === 'addPolicyOnSignUp' && this.acmicService.isACMIC())) {
        group[input.key] = new FormControl
        (
          input.value, 
          [
            Validators.required, 
            Validators.maxLength(input.maxLength),
            Validators.minLength(input.minLength),
            Validators.pattern(policyPattern),
          ]
        );
      } else if (input.key === 'addPolicyOnSignUp') {
        group[input.key] = new FormControl
        (
          input.value, 
          [
            Validators.required, 
            Validators.maxLength(input.maxLength),
            Validators.minLength(input.minLength),
            Validators.pattern(legacyPolicyPattern),
          ]
        );
      } else if (input.inputType == 'bank_account_number') {
        group[input.key] = new FormControl
        (
          input.value, 
          [
            Validators.required, 
            Validators.maxLength(input.maxLength),
            Validators.minLength(input.minLength)
          ]
        );
      }
      else if (input.key == 'repeatPassword') {
        group[input.key] = new FormControl
        (
          input.value,
          [
            Validators.required,
          ]
        );
        } else if (input.key == 'noPhoneEmail_zipcode') {
          group[input.key] = new FormControl
        (
          input.value, 
          [
            Validators.required, 
            Validators.maxLength(input.maxLength),
            Validators.minLength(input.minLength),
            Validators.pattern(numberPattern),
          ]
        );
        } else {
        group[input.key] = input.required ? 
          new FormControl(input.value || '',  [ Validators.required ] ) : 
          new FormControl(input.value || '');
      }
    });
    return new FormGroup(group);
  }
}
